import { useCallback, useRef } from 'react';
import { useLocation } from 'quartz-routing/react-router';
import { getIsIframePreviewUrl } from '../utils/urls';
import { trackPageFormFieldFirstInteraction } from '../utils/tracking';
import Raven from 'raven-js';
import { INTERACTION_SECTIONS, INTERACTION_TARGETS } from 'payments-checkout-lib/constants/PageInteractionTracking';
const usePageInteractionTracking = () => {
  const firstInteractionCacheRef = useRef({});
  const {
    pathname
  } = useLocation();
  const isRouteIframePreview = getIsIframePreviewUrl(pathname);
  const trackFirstFormFieldInteraction = useCallback(({
    section,
    target
  }) => {
    try {
      var _firstInteractionCach;
      if (isRouteIframePreview || (_firstInteractionCach = firstInteractionCacheRef.current[section]) !== null && _firstInteractionCach !== void 0 && _firstInteractionCach[target] || !(target in INTERACTION_TARGETS) || !(section in INTERACTION_SECTIONS)) {
        return;
      }
      firstInteractionCacheRef.current = Object.assign({}, firstInteractionCacheRef.current, {
        [section]: Object.assign({}, firstInteractionCacheRef.current[section], {
          [target]: true
        })
      });
      trackPageFormFieldFirstInteraction(section, target);
    } catch (error) {
      Raven.captureMessage('usePageInteractionTracking error', {
        extra: {
          message: error && error.message
        }
      });
    }
  }, [isRouteIframePreview]);
  return {
    trackFirstFormFieldInteraction
  };
};
export default usePageInteractionTracking;